import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

export async function startSession({ name, email, employeeId, organizationId, userId, role }) {
  const res = await axios.post(`${BACKEND_URL}/startSession`, {
    name,
    email,
    employeeId,
    organizationId,
    userId,
    role,
  });
  return res.data;
}

export async function submitReport({ id, name, email, employeeId, organizationId, userId, role }) {
  const res = await axios.post(`${BACKEND_URL}/submitReport`, {
    id,
    name,
    email,
    employeeId,
    organizationId,
    userId,
    role,
  });
  return res.data;
}
